<template>
  <form data-vv-scope="invoice">
    <h3 class="text-primary">Emisión de Factura Electrónica</h3>
    <TableReceiptDetail
      :columns="columns"
      :mappedReceiptDataTable="mappedReceiptDataTable"
    />
    <h5>
      Información del receptor
    </h5>
    <b-card>
      <div class="row">
        <div class="col-6 mt-3">
          <b-form-group
            label="Rut receptor"
          >
            <b-form-input
              v-model="invoice.iut"
              type="text"
            />
          </b-form-group>
        </div>
        <div class="col-6 mt-3">
          <b-form-group
            label="Razón Social"
          >
            <b-form-input
              v-model="invoice.businessName"
              type="text"
            />
          </b-form-group>
        </div>
        <div class="col-6 mt-3">
          <b-form-group
            label="Giro"
          >
            <b-form-input
              v-model="invoice.commercialName"
              type="text"
            />
          </b-form-group>
        </div>
        <div class="col-6 mt-3">
          <b-form-group
            label="Dirección"
          >
            <b-form-input
              v-model="invoice.address"
              type="text"
            />
          </b-form-group>
        </div>
        <div class="col-6 mt-3">
          <b-form-group
            label="Ciudad/provincia"
          >
            <b-form-input
              v-model="invoice.city"
              type="text"
            />
          </b-form-group>
        </div>
        <div class="col-6 mt-3">
          <b-form-group
            label="Comuna"
          >
            <b-form-input
              v-model="invoice.commune"
              type="text"
            />
          </b-form-group>
        </div>
        <div class="col-6 mt-3">
          <b-form-group
            label="Teléfono"
          >
            <b-form-input
              v-model="invoice.phone"
              type="text"
            />
          </b-form-group>
        </div>
        <div class="col-6 mt-3">
          <b-form-group
            label="Correo"
          >
            <b-form-input
              v-model="invoice.email"
              type="text"
            />
          </b-form-group>
        </div>
        <div class="col-6 mt-3">
          <b-form-group
            label="Fecha de emisión"
          >
            <b-form-datepicker
              name="date"
              v-model="invoice.issueDate"
              data-vv-as="fecha de emisión"
              :state="errors.has('invoice.date') ? false : null"
              v-validate="'required'"
              label-no-date-selected="No se ha seleccionado fecha"
              label-help="Puede usar las flechas del teclado y espacio"
            />
            <b-form-invalid-feedback>
              {{ errors.first('invoice.date') }}
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
        <div class="col-12 text-right">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            class="btn-icon"
          >
            <vs-icon icon="search"/>
            Vista previa
          </b-button>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="success"
            class="ml-4 btn-icon"
            @click="submitInvoice"
          >
            <vs-icon icon="save"/>
            Emitir
          </b-button>
        </div>
      </div>
    </b-card>
  </form>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import { getReceiptDetails, searchAllReceipts } from '@/febos/aduanas/receipts/store/actions';
import { detailsReceipt, receipts, detailsSelectedReceipts } from '@/febos/aduanas/receipts/store/getters';
import TableReceiptDetail from '@/febos/aduanas/receipts/views/components/TableReceiptDetail';
import InvoiceMapInfoMixin from '@/febos/aduanas/receipts/views/utils/InvoiceMapInfoMixin';
import { ioGetCompanyData } from '@/febos/servicios/api/empresas.api';
import { batchesStates } from '@/febos/aduanas/batches/views/utils/constants';

export default {
  name: 'InvoiceReceipt',
  mixins: [InvoiceMapInfoMixin],
  components: { TableReceiptDetail },
  data() {
    return {
      companyDataComplete: {},
      totals: {
        subtotal: 0,
        net: 0, // neto
        exempt: 0, // exento
        discount: 0, // descuentos
        surcharge: 0, // cargos
        iva: 0,
        deliveryAmount: 0, // montoFlete
        safeAmount: 0, // monto seguro
        additional: [], // adicionales
        totalAdditional: 0, // total adicionales
        total: 0
      },
      massiveProcess: false,
      selectedReceipts: [],
      receipt: {},
      febosAdicional: [],
      writeAmount: '',
      invoice: {},
      columns: [
        { key: 'numeroLote', label: 'Folio lote' },
        { key: 'monto', label: 'Monto neto' },
        { key: 'aduanaGestora', label: 'Aduana gestora' },
        { key: 'estado', label: 'Estado' },
      ],
    };
  },
  watch: {
    detailsReceipt() {
      const { adjudicatarios } = this.detailsReceipt;
      this.invoice = {
        ...this.invoice,
        iut: adjudicatarios.rut,
        businessName: adjudicatarios.nombre,
        commercialName: adjudicatarios.giro,
        address: adjudicatarios.direccion,
        city: adjudicatarios.ciudad,
        commune: adjudicatarios.comuna,
        phone: adjudicatarios.telefono,
        email: adjudicatarios.correo
      };
    }
  },
  computed: {
    ...mapGetters('receipts', {
      detailsReceipt: detailsReceipt.name,
      detailsSelectedReceipts: detailsSelectedReceipts.name,
      receipts: receipts.name
    }),
    mappedReceiptDataTable() {
      if (this.massiveProcess || this.detailsSelectedReceipts.length) {
        return this.detailsSelectedReceipts.map((receipt) => ({
          numeroLote: receipt.lote.folio,
          monto: receipt.monto,
          aduanaGestora: receipt.subasta.gestora.razonSocial,
          estado: batchesStates[receipt.lote.estado].label
        }));
      }
      return [
        {
          numeroLote: this.detailsReceipt.lote.folio,
          monto: this.detailsReceipt.monto,
          aduanaGestora: this.detailsReceipt.subasta.gestora.razonSocial,
          estado: batchesStates[this.detailsReceipt.lote.estado].label
        }
      ];
    }
  },
  methods: {
    ...mapActions('receipts', {
      getReceiptDetails: getReceiptDetails.name,
      searchAllReceipts: searchAllReceipts.name
    }),
    getSelectedReceiptsData() {
      const { adjudicatarios } = this.detailsSelectedReceipts[0];
      this.invoice = {
        ...this.invoice,
        iut: adjudicatarios.rut,
        businessName: adjudicatarios.nombre,
        commercialName: adjudicatarios.giro,
        address: adjudicatarios.direccion,
        city: adjudicatarios.ciudad,
        commune: adjudicatarios.comuna,
        phone: adjudicatarios.telefono,
        email: adjudicatarios.correo
      };
    },
    submitInvoice() {
      // se llama al endpoint pra generar la factura
    }
  },
  async created() {
    const { data } = await ioGetCompanyData({ companyIut: this.company.iut });
    this.companyDataComplete = data;
    if (this.$route.name === 'invoiceReceiptMassive') {
      this.selectedReceipts = this.receipts.filter((receipt) => receipt.selected);
      await this.searchAllReceipts(this.selectedReceipts);
      await this.getSelectedReceiptsData();
      this.massiveProcess = true;
      return;
    }
    const { comprobanteId } = this.$route.params;
    await this.getReceiptDetails(comprobanteId);
    const { adjudicatarios } = this.detailsReceipt;
    this.invoice = {
      ...this.invoice,
      iut: adjudicatarios.rut,
      businessName: adjudicatarios.nombre,
      commercialName: adjudicatarios.giro,
      address: adjudicatarios.direccion,
      city: adjudicatarios.ciudad,
      commune: adjudicatarios.comuna,
      phone: adjudicatarios.telefono,
      email: adjudicatarios.correo
    };
  }
};
</script>
<style>

</style>
